<ion-toolbar noUnderline>
  <ion-buttons slot="end">
    @if (item.translation?.showTranslate) {
      <ion-button class="translate" (click)="handleTranslateItem()">
        @if (!item.translation?.inProgress) {
          <ion-icon src="/assets/icon/translate-icon.svg"></ion-icon>
        }
        @if (item.translation?.inProgress) {
          <ion-spinner name="crescent"></ion-spinner>
        }
      </ion-button>
    }
    @if (item.translation?.showRevert) {
      <ion-button class="show-original" (click)="handleShowOriginalItem()">
        Show original
      </ion-button>
    }
    <ion-button (click)="handleShareItem()">
      <ion-icon class="shareIcon" src="/assets/icon/share-icon.svg"></ion-icon>
    </ion-button>
    @if (!item.done && !item.presub) {
      <ion-button (click)="handleToggleItemDone()">
        <ion-icon class="doneIcon" src="/assets/icon/done-icon.svg"></ion-icon>
      </ion-button>
    }
    @if (item.done && !item.presub) {
      <ion-button (click)="handleToggleItemDone()">
        <ion-icon class="undoIcon" src="/assets/icon/undo-icon.svg"></ion-icon>
      </ion-button>
    }
    @if (item.presub) {
      <ion-button>
        <ion-icon class="oldPostIcon" src="/assets/icon/old-post-icon.svg"></ion-icon>
      </ion-button>
    }
    <app-item-reaction
      [reaction]="item.reaction"
      [allowedReactions]="item.allowedReactions"
    (reactWith)="handleReactWith($event)"></app-item-reaction>
  </ion-buttons>
</ion-toolbar>
